export const FETCH_CHAPTER = 'FETCH_CHAPTER';
